import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import AverageProductSellFilter from "../filters/AverageProductSellFilter";
import fetchHook from "../../../../../hooks/fetchMSSQL-hook";
import getGradientForBarValue from "../../utils/getGradientForBarValue";
import getProductsSalesAverageChartConfig from "../../configs/getProductsSalesAverageChartConfig";
import getProductsSalesSumChartConfig from "../../configs/getProductsSalesSumChartConfig";
import "../plugins/CustomChartFilter.css";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
  annotationPlugin
);

export default function ProductsSalesCharts({showProductsStat, setShowProductsStat}) {
  const chartRef = useRef(null);
  const chartRef2 = useRef(null);
  const { fetchMssqlApi } = fetchHook();
  const [avarageProductsSale, setAvarageProductsSale] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [productFilter, setProductFilter] = useState("");
  const [productType, setProductType] = useState(1);
  const [productRank, setProductRank] = useState("all"); 
  // const [showProductsStat, setShowProductsStat] = useState(true); 
  const [sortType, setSortType] = useState(2);
  const [showAVGofAVG, setShowAVGofAVG] = useState(true);
  const [showAVGofSUM, setShowAVGofSUM] = useState(true);
  const [showAVG, setShowAVG] = useState(false);
  const [showMedian, setShowMedian] = useState(true);

  const getAvarageProductsSales = async () =>
    fetchMssqlApi(
      "/stat/avarage-products-sales",
      {
        method: "POST",
        hideNotification: true,
      },
      (res) => {
        setAvarageProductsSale(res);
        sortData(sortType);
      },
      (err) => console.log(err)
    );

  const setLocalStorage = (value) => {
    try {
      const values = localStorage.getItem("statFilters");
      let parsedValue = {};
      
      if (values) {
        parsedValue = JSON.parse(values);
      }
      
      const updatedValue = { ...parsedValue, showProductsStat: value };
      localStorage.setItem("statFilters", JSON.stringify(updatedValue));
    } catch (e) {
      console.log("Error updating localStorage:", e);
    }
  };

  const filterByProductType = (productType) => {
    switch (parseInt(productType)) {
      case 1:
        return avarageProductsSale.filter(({ IsRecipe }) => !IsRecipe);
      case 2:
        return avarageProductsSale.filter(({ IsRecipe }) => IsRecipe);
      default:
        return avarageProductsSale;
    }
  };

  const filteredByType = avarageProductsSale
    ? filterByProductType(productType)
    : [];




  
  const filteredData = filteredByType

  const sortBySummaryASC = (a, b) =>
    +a.SummaryIncomeValue > +b.SummaryIncomeValue ? 1 : -1;
  const sortByAvarageASC = (a, b) =>
    +a.AverageIncomeValue > +b.AverageIncomeValue ? 1 : -1;
  const sortByProductNameASC = (a, b) =>
    a.ProductFullName > b.ProductFullName ? 1 : -1;
  const sortBySummaryDESC = (a, b) =>
    +a.SummaryIncomeValue < +b.SummaryIncomeValue ? 1 : -1;
  const sortByAvarageDESC = (a, b) =>
    +a.AverageIncomeValue < +b.AverageIncomeValue ? 1 : -1;
  const sortByProductNameDESC = (a, b) =>
    a.ProductFullName < b.ProductFullName ? 1 : -1;

  const sortData = (caseType) => {
    switch (+caseType) {
      case 1:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
      case 2:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByAvarageDESC)
        );
      case 3:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByProductNameDESC)
        );
      case 4:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortBySummaryASC)
        );
      case 5:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByAvarageASC)
        );
      case 6:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortByProductNameASC)
        );
      default:
        return setAvarageProductsSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
    }
  };

  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  const getCurrentPageData = () => {
    if (!filteredData || filteredData.length === 0) return [];

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  // const currentData = getCurrentPageData()
  const applyRankFilter = (data) => {
    if (!data || data.length === 0) return [];
    
    switch (productRank) {
      case "best":
        return data.slice(0, 50);
      case "worst":
        return data.slice(Math.max(0, data.length - 50)); 
      case "all":
      default:
        return data; 
    }
  };
  const currentData = applyRankFilter(filteredData);

  const calculateMedianOfAverages = () => {
    if (!filteredData || filteredData.length === 0) return 0;

    const sortedValues = [...filteredData]
      .map((machine) => parseFloat(machine.AverageIncomeValue || 0))
      .sort((a, b) => a - b);

    const midIndex = Math.floor(sortedValues.length / 2);

    if (sortedValues.length % 2 !== 0) {
      return sortedValues[midIndex];
    } else {
      return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
    }
  };

  const calculateMedianOfSum = () => {
    if (!filteredData || filteredData.length === 0) return 0;

    const sortedValues = [...filteredData]
      .map((machine) => parseFloat(machine.SummaryIncomeValue || 0))
      .sort((a, b) => a - b);

    const midIndex = Math.floor(sortedValues.length / 2);

    if (sortedValues.length % 2 !== 0) {
      return sortedValues[midIndex];
    } else {
      return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
    }
  };

  const medianOfAverages = calculateMedianOfAverages();
  const medianOfSum = calculateMedianOfSum();

  useEffect(() => {
    sortData(sortType);
  }, [sortType]);


  useEffect(() => {
    setLocalStorage(showProductsStat);
  }, [showProductsStat]);

  useEffect(() => {
    setCurrentPage(1);
  }, [productType, productFilter, productRank]); 

  useEffect(() => {
    if (showProductsStat) {
      getAvarageProductsSales();
    }
    if (!showProductsStat) {
      setProductFilter("");
    }
    setCurrentPage(1);
  }, [showProductsStat]);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
    if (chartRef2.current) {
      chartRef2.current.update();
    }
  }, [avarageProductsSale]);

  const calculateAverageOfAverages = () => {
    if (!avarageProductsSale || avarageProductsSale.length === 0) return 0;

    const sum = avarageProductsSale.reduce(
      (acc, product) => acc + parseFloat(product.AverageIncomeValue || 0),
      0
    );
    return sum / avarageProductsSale.length;
  };
  const calculateAverageOfSum = () => {
    if (!avarageProductsSale || avarageProductsSale.length === 0) return 0;

    const sum = avarageProductsSale.reduce(
      (acc, product) => acc + parseFloat(product.SummaryIncomeValue || 0),
      0
    );
    return sum / avarageProductsSale.length;
  };

  const averageOfAverages = calculateAverageOfAverages();
  const averageOfSum = calculateAverageOfSum();

  const truncateProductName = (name) => {
    return name && name.length > 30 ? name.substring(0, 30) + "..." : name;
  };

  const maxAvarageValue = Math.max(
    ...avarageProductsSale.map(
      ({ AverageIncomeValue }) => parseFloat(AverageIncomeValue) || 0
    )
  );
  const maxSummaryValue = Math.max(
    ...avarageProductsSale.map(
      ({ SummaryIncomeValue }) => parseFloat(SummaryIncomeValue) || 0
    )
  );
  const summaryChartRatio =
    ((maxAvarageValue || 1) / (averageOfSum || 1)).toFixed(1) || 0;
  const avarageChartRatio =
    ((maxSummaryValue || 1) / (averageOfAverages || 1)).toFixed(1) || 0;

  useEffect(() => {
    if (chartRef.current && chartRef.current.canvas) {
      try {
        const chart = chartRef.current;

        if (chart.data && chart.data.datasets) {
          chart.data.datasets[0].backgroundColor = currentData.map(
            (product) => {
              const value = parseFloat(product.AverageIncomeValue);
              return getGradientForBarValue(
                chart,
                value,
                averageOfAverages,
                avarageChartRatio
              );
            }
          );

          chart.update();
        }
      } catch (e) {
        console.error("Failed to apply gradients to first chart:", e);
      }
    }

    if (chartRef2.current && chartRef2.current.canvas) {
      try {
        const chart = chartRef2.current;

        if (chart.data && chart.data.datasets) {
          chart.data.datasets[0].backgroundColor = currentData.map(
            (product) => {
              const value = parseFloat(product.SummaryIncomeValue);
              return getGradientForBarValue(
                chart,
                value,
                averageOfSum,
                summaryChartRatio
              );
            }
          );

          chart.update();
        }
      } catch (e) {
        console.error("Failed to apply gradients to second chart:", e);
      }
    }
  }, [currentData, currentPage, averageOfAverages, averageOfSum]);

  const chartData = {
    labels:
      currentData?.map(
        (product) =>
          truncateProductName(product.ProductFullName)
          // product.ProductFullName
      ) || [],
    datasets: [
      {
        data:
          currentData?.map((product) =>
            parseFloat(product.AverageIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };

  const chartData2 = {
    labels:
      currentData?.map(
        (product) =>
          truncateProductName(product.ProductFullName)
          // product.ProductFullName
      ) || [],
    datasets: [
      {
        data:
          currentData?.map((product) =>
            parseFloat(product.SummaryIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };

  return (
    <div
      // className={`pb-2 ${
      //   showProductsStat && "border-top border-bottom rounded"
      // }`}
    >
      <AverageProductSellFilter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        productFilter={productFilter}
        setProductFilter={setProductFilter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        filteredData={filteredData}
        totalCount={avarageProductsSale ? avarageProductsSale.length : 0}
        products={
          avarageProductsSale.length
            ? avarageProductsSale.map(({ ProductFullName }) => ProductFullName)
            : []
        }
        isVisible={showProductsStat}
        setIsVisible={setShowProductsStat}
        setSortType={setSortType}
        sortType={sortType}
        productType={productType}
        setProductType={setProductType}
        productRank={productRank}
        setProductRank={setProductRank}
        showAVG={showAVG}
        setShowAVG={setShowAVG}
        getData={getAvarageProductsSales}
        showMedian={showMedian}
        setShowMedian={setShowMedian}
      />
      {filteredData.length === 0 && productFilter && (
        <div
          className="alert"
          style={{ backgroundColor: "#C5D8FF", fontWeight: "bolder" }}
        >
          Nie znaleziono produktów pasujących do filtra "{productFilter}"
        </div>
      )}
      {showProductsStat && (
        <div
          className="container-fluid"
          style={{ maxHeight: "80vh", maxWidth: "90vw", overflow: "auto" }}
        >
          <div className="row">
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length || 1) * 30
                )}px`,
                overflowY: "auto",
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              {/* <Bar ref={chartRef} data={chartData} options={getProductsSalesAverageChartConfig(showAVGofAVG, setShowAVGofAVG, currentData, averageOfAverages, itemsPerPage)} /> */}
              <Bar
                ref={chartRef}
                data={chartData}
                options={getProductsSalesAverageChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfAverages,
                  itemsPerPage,
                  showMedian,
                  medianOfAverages
                )}
              />
            </div>
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length || 1) * 30
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              {/* <Bar ref={chartRef2} data={chartData2} options={getProductsSalesSumChartConfig(showAVGofSUM, setShowAVGofSUM, currentData, averageOfSum, itemsPerPage)} /> */}
              <Bar
                ref={chartRef2}
                data={chartData2}
                options={getProductsSalesSumChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfSum,
                  itemsPerPage,
                  showMedian,
                  medianOfSum
                )}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
